var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-popup"},[_c('van-popup',{style:({ height: _vm.height }),attrs:{"closeable":"","position":_vm.position},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }